import React, { useEffect, useState, useMemo, useRef } from "react";
import "../style.scss";
import "antd/dist/antd.css";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { homeSelector } from "redux/selectors/homeSelector";
import { courseSelector } from "redux/selectors/courseSelector";
import { sponsorDashboardSelector } from "redux/selectors/sponsorDashboard";
import { Tabs, Skeleton, Form, Checkbox, Table, Tag, notification } from "antd";
import { ScaleText, CustomCheckbox, CustomButton } from "components";
import { convertToLocalTime } from "utils/format";
import { INTERNAL_LINKS } from "enum";
import ProgramCards from "../CardsDashboards/Cards";
import CardUser from "./CardUser";
import FacultyCurrentDashboardItem from "./FacultyDiscussionBoard";
import { envSelector } from "redux/selectors/envSelector";
import { getSponsorsDashboardCases } from "redux/actions/dashboard-sponsors-actions";
import { Modal } from "antd";
import { EditOutlined } from "@ant-design/icons";
import {notifySponsor,saveDataSponsor} from "../../../api/module/sponsorDashboard";
import ModalEditInfo from "./ModalEditInfo";

const DashboardSponsors = ({ userProfile, match, getSponsorsDashboardCases, dashboards }) => {
  const [currentTab, setCurrentTab] = useState("0");
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const [porcent, setPorcent] = useState(0);
  const [visible, setVisible] = useState(false)
  const [idDeliverable, setIdDeliverable] = useState(null)
  const [reduceMembers, setReduceMembers] = useState(null);
  const [loadingNotify, setLoadingNotify] = useState(false)
  const [hasDiscussionBoardNotification, setHasDiscussionBoardNotification] = useState(false)
  const [hasDeliverableNotification, setHasDeliverableNotification] = useState(false)
  const [requestState, setRequestState] = useState({
    delivers:0,
    templates:0,
    firstData:1,
  })
  const formControl = useRef(null);
  const formControl2 = useRef(null);
  const clock = useRef(null);
  const clock1 = useRef(null);
  const clock2 = useRef(null);
  const slug = match.params.data;
  let styleElementShedule = {margin: "0px",marginTop: "5px",marginBottom: "5px"};

  const notifyRe = async (data,caseSpecific,callback) => {
    try {
        const response = await notifySponsor({...data,caseSpecific});

        if (response.status === 200) {
          if(typeof callback === 'function'){
            callback()
          }
        }
    } catch (error) {
      console.log(error);
      setLoadingNotify(false)
    }
  }

  const saveDataSp = async (data) => {
    try {
        await saveDataSponsor(data);
    } catch (error) {
        console.log(error);
    }
  }

  const orderDelivers = (data) => {
    let deliversObject = data.reduce((acc, obj, index) => {
      acc[obj.idOrder] = {
          ...obj,
          idOrder: index,
          approvers: (obj || {}).approvers || [],
          expectedReadyDatee: (obj || {}).expectedReadyDate,
          expectedReviewDatee: (obj || {}).expectedReviewDate,
          expectedDeliverDatee: (obj || {}).expectedDeliverDate,
          expectedReadyDate: moment((obj || {}).expectedReadyDate).utc(),
          expectedReviewDate: moment((obj || {}).expectedReviewDate).utc(),
          expectedDeliverDate: moment((obj || {}).expectedDeliverDate).utc(),
      }; 
      return acc;
    }, {}); 

    return(dashboards[slug]?.firstData?.order || []).map(e => {
        return deliversObject[Number(e)];
    });
  }

  const cargCheckDeliver = (data) => {
    if(clock1.current){ clearTimeout(clock1.current); };
    clock1.current = setTimeout(() => {
      saveDataSp({
        idDashboard: dashboards[slug]?.firstData?.id,
        checklistDeliverables: data
      })
    }, 500);
  }

  const cargCheckInteraction = (data) => {
    if(clock.current){ clearTimeout(clock.current); };
    clock.current = setTimeout(() => {
      saveDataSp({
        idDashboard: dashboards[slug]?.firstData?.id,
        checklistSelected: data
      })
    }, 500);
  }

  let containerDeliverables = () => {
    return <div className="container-content-tabs">
      {userProfile?.role === 'admin' && <div className="container-edit-icon"
        onClick={() => {
          visible.modal(true);
          visible.set({
            order: dashboards[slug]?.firstData?.order,
            deliverables: dashboards[slug]?.delivers,
            SponsorsDashboardsMembers: dashboards[slug]?.firstData?.SponsorsDashboardsMembers
          },'Deliverables')
        }}
      >
        <EditOutlined style={{color:'white',fontSize:'30px'}}/>
      </div>}
      <Form
          form={form2}
          ref={formControl2}
          style={{width:'100%',display:'flex',justifyContent:'flex-start'}}
        >
          <Form.Item
            className="form-data-larg"
            name="checksD"
            style={{width:'100%'}}
            label=""
          >
            <Checkbox.Group style={{width:'100%'}} onChange={(data) => {
              let checks = form2.getFieldValue("checksD");
              cargCheckDeliver(checks);
            }}>
              {orderDelivers(dashboards[slug]?.delivers || [])?.map((e, index) => {
                let startTime = convertToLocalTime(e?.expectedReadyDatee, 'America/Los_Angeles');
                let endTime = convertToLocalTime(e?.expectedDeliverDatee, 'America/Los_Angeles');
                let background = e?.design === "Co-branded" ? "#e9d9f7" : "#ffe58f";
                let borderColor = e?.design === "Co-branded" ? "#e9d9f7" : "#ffe58f";
                let accesDeliver = e?.approvers?.includes(userProfile.id);
                let hasDeliverable = hasDeliverableNotification[e?.id];
                return (
                  <div className="card-shedule" style={{padding:'20px',background, borderColor }}>
                    <h2>{e?.name} {`${hasDeliverable}`}</h2>
                    <>
                      <p style={styleElementShedule}>
                        <b>Type:</b>{" "}{e?.type}
                      </p>
                      <p style={styleElementShedule}>
                        <b>Design:</b>{" "}{e?.design}
                      </p>
                      <p style={styleElementShedule}>
                        <b>Expected Ready Date:</b>{" "}
                        {(startTime || moment())?.format("MMMM DD, YYYY")}
                        {/* {" at "}{(startTime || moment())?.format("HH:mm")}
                        {" "}{moment.tz.guess()} */}
                      </p>
                      <p style={styleElementShedule}>
                        <b>Expected Delivery Date:</b>{" "}
                        {(endTime || moment())?.format("MMMM DD, YYYY")}
                        {/* {" at "}{(endTime || moment())?.format("HH:mm")}
                        {" "}{moment.tz.guess()} */}
                      </p>
                      <div style={styleElementShedule}>
                        <b>Description:</b><div
                          className={"container-descriptionnn"}
                          dangerouslySetInnerHTML={{__html: e?.description}}
                        />
                      </div>
                      <p style={styleElementShedule}>
                        <b>Approver:</b>{" "}
                        {(e?.approvers || []).map(a => {
                          return <Tag color="gray" style={{width:'auto'}}>{((reduceMembers || {})[a] || {}).firstName}{" "}{((reduceMembers || {})[a] || {}).lastName}</Tag>
                        })}
                      </p>
                      <div>
                        <p style={styleElementShedule}><b>Relevant Links:</b></p>
                        <div style={{display:'flex',flexDirection:'column', width:'150px',gap:'10px'}}>
                          {(e?.relevantLinks || []).map(a => {
                            return <a href={a} target="_blank">{a}</a>
                          })}
                        </div>
                      </div>
                      <div className="container-check-deliver">
                        <CustomCheckbox 
                          disabled={!accesDeliver} 
                          key={index} 
                          value={e?.id}
                          onChange={(a) => {
                            if(clock2.current){ clearTimeout(clock.current); };
                            if(a.target.checked){
                              clock2.current = setTimeout(() => {
                                notifyRe(
                                  {
                                    emails: Object.values(reduceMembers || [])?.filter(f => f.role === 'admin')?.map(f => f.email),
                                    title: e?.name,
                                    firstName: userProfile?.firstName
                                  },
                                  'notificationApprover',
                                  () => {
                                    notification.info({
                                      message: "APPROVED",
                                    });
                                  }
                                )
                              }, 1000);
                            }
                          }}
                        >APPROVED</CustomCheckbox>
                      </div>
                      {userProfile?.role === 'admin' &&
                        <CustomButton 
                          onClick={() => {
                            setLoadingNotify(true)
                            notifyRe(
                              {emails:(e?.approvers || []).map(a => ((reduceMembers || {})[a] || {}).email)},
                              'notify',
                              () => {
                                setLoadingNotify(false);
                                notification.info({
                                  message: "Sponsor has been notified",
                                });
                              }
                            )
                          }}
                          type="secondary" 
                          text="NOTIFY SPONSOR" 
                          size="xs" 
                          loading={loadingNotify}
                          style={{marginTop:'10px',width:'250px'}}
                        />
                      }
                      <CustomButton 
                        onClick={() => { 
                          setIdDeliverable(e);
                          let newChangeDleiverableNotification = hasDeliverableNotification;
                          delete newChangeDleiverableNotification[e?.id];
                          setHasDeliverableNotification(newChangeDleiverableNotification);
                        }}
                        type="secondary" 
                        text={<p style={{margin:'0px',padding:'0px',position:'relative'}}>
                          CHAT
                          {hasDeliverable && (
                            <span
                              style={{
                                position: "absolute",
                                right: "-16px",
                                width: "16px",
                                height: "16px",
                                backgroundColor: "red",
                                borderRadius: "50%",
                                border: "2px solid white",
                              }}
                            />
                          )}  
                        </p>} 
                        size="xs" 
                        style={{marginTop:'10px',width:'250px'}}
                      />
                    </>
                  </div>
                );
              })}
            </Checkbox.Group>
          </Form.Item>
        </Form>
    </div>
  };

  const groupCheckbox = () => {
    if (dashboards[slug]?.firstData?.checkList) {
      return <Form
        form={form}
        ref={formControl}
        style={{width:'100%',display:'flex',justifyContent:'flex-start'}}
      >
         <Form.Item
            className="form-data-larg"
            name="checks"
            label=""
          >
                <Checkbox.Group onChange={() => {
                  let checks = form.getFieldValue("checks");
                  setPorcent((((checks || []).length * 100) / dashboards[slug]?.firstData?.checkList?.length).toFixed(1))
                  cargCheckInteraction(checks)
                }}>
                  {(dashboards[slug]?.firstData?.checkList || []).map((check, index) => (
                    <CustomCheckbox key={index} value={check}>
                      {check}
                    </CustomCheckbox>
                  ))}
              </Checkbox.Group>
          </Form.Item>
      </Form>
    } else {
      return (<div></div>)
    }
  }

  const instructorContainer = (dashboards[slug]?.firstData?.SponsorsDashboardsMembers || []).map((item, index) => {
    return (
      <CardUser
        user={item?.User}
        key={index}
      />
    );
  });

  useEffect(() => {
    if(dashboards[slug]?.firstData){
      let myuser = (dashboards[slug]?.firstData?.SponsorsDashboardsMembers || []).filter(e => e?.User?.id === userProfile?.id);
      let checks = (myuser || [])[0]?.checklistSelected;
      let checksD = (myuser || [])[0]?.checklistDeliverables;
      if((checks || []).length > 0){
        setPorcent((((checks || []).length * 100) / dashboards[slug]?.firstData?.checkList?.length).toFixed(1))
        form.setFieldsValue({checks: checks});
      }
      if((checksD || []).length > 0){
        form2.setFieldsValue({checksD: checksD.map(e => Number(e))});
      }
      setReduceMembers((dashboards[slug]?.firstData?.SponsorsDashboardsMembers || []).reduce((acc, obj, index) => {
        acc[obj.User.id] = obj.User; 
        return acc;
      }, {}))
    }
    if(requestState?.firstData === 1){
      getSponsorsDashboardCases({id:slug, cases:'firstData', uniqueLink:slug})
      setRequestState({...requestState,firstData:2})
    }
    if(requestState?.delivers === 1 && !dashboards[slug]?.delivers){
      getSponsorsDashboardCases({id:dashboards[slug]?.firstData?.id, cases:'delivers', uniqueLink:slug})
      setRequestState({...requestState,delivers:2})
    }
    if(requestState?.templates === 1 && !dashboards[slug]?.templates){
      getSponsorsDashboardCases({id:dashboards[slug]?.firstData?.id, cases:'templates', uniqueLink:slug})
      setRequestState({...requestState,templates:2})
    }
  },[dashboards[slug],requestState])
  
  const dataSourceColumns = [
    {
      title: <p style={{padding:'0px',margin:'0px',textAlign:'center',fontWeight:'bold'}}>Deliverable</p>,
      dataIndex: "name",
      key: "name",
      width: 150,
      render: (data,all) => {
        let background = all?.design === "Co-branded" ? "#e9d9f7" : "#ffe58f";
        let borderColor = all?.design === "Co-branded" ? "#e9d9f7" : "#ffe58f";
        return <>
          <div style={{position:'absolute',left:'0px',top:'0px',width:'100%',background,borderColor, height:'100%',zIndex:'1'}}></div>
          <p style={{margin:'0px',padding:'0px',zIndex:'10',position:'relative'}}>{data}</p>
        </>
      }
    },
    {
      title: <p style={{padding:'0px',margin:'0px',textAlign:'center',fontWeight:'bold'}}>Relevant Links</p>,
      dataIndex: "relevantLinks",
      key: "relevantLinks",
      render: (data) => {
        return <div style={{zIndex:'10',position:'relative',display:'flex',flexDirection:'column', width:'150px',gap:'5px'}}>
          {data.map(e => {
            return <a href={e} target="_blank">{e}</a>
          })}
        </div>
      },
    },
    {
      title: <p style={{padding:'0px',margin:'0px',textAlign:'center',fontWeight:'bold'}}>Ready by Hacking HR Date</p>,
      dataIndex: "expectedReadyDatee",
      key: "expectedReadyDatee",
      render: (data) => {
        let startTime = convertToLocalTime(data, 'America/Los_Angeles');
        return <p style={{margin:'0px',padding:'0px',zIndex:'10',position:'relative'}} >
          {(startTime || moment())?.format("MMMM DD, YYYY")}
          {/* {" at "}{(startTime || moment())?.format("HH:mm")}
          {" "}{moment.tz.guess()} */}
          </p>
      },
    },
    {
      title: <p style={{padding:'0px',margin:'0px',textAlign:'center',fontWeight:'bold'}}>Review by Sponsor Date</p>,
      dataIndex: "expectedReviewDatee",
      key: "expectedReviewDatee",
      render: (data) => {
        let startTime = convertToLocalTime(data, 'America/Los_Angeles');
        return <p style={{margin:'0px',padding:'0px',zIndex:'10',position:'relative'}}>
          {(startTime || moment())?.format("MMMM DD, YYYY")}
          {/* {" at "}{(startTime || moment())?.format("HH:mm")}
          {" "}{moment.tz.guess()} */}
          </p>
      },
    },
    {
      title: <p style={{padding:'0px',margin:'0px',textAlign:'center',fontWeight:'bold'}}>Delivery Date</p>,
      dataIndex: "expectedDeliverDatee",
      key: "expectedDeliverDatee",
      render: (data) => {
        let startTime = convertToLocalTime(data, 'America/Los_Angeles');
        return <p style={{margin:'0px',padding:'0px',zIndex:'10',position:'relative'}}>
          {(startTime || moment())?.format("MMMM DD, YYYY")}
          {/* {" at "}{(startTime || moment())?.format("HH:mm")}
          {" "}{moment.tz.guess()} */}
          </p>
      },
    },
  ];

  const reemplazarLinksPorHTML = (texto='') => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(texto, 'text/html');
    
    // Recorrer nodos y reemplazar textos que contengan URLs fuera de etiquetas <a>.
    const walkNodes = (node) => {
      node.childNodes.forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          // Reemplazar solo en nodos de texto
          const patron = /(https?:\/\/[^\s<>"']+)/g;
          const nuevoHTML = child.textContent.replace(
            patron,
            '<a href="$1" target="_blank">$1</a>'
          );
          if (nuevoHTML !== child.textContent) {
            const span = document.createElement('span');
            span.innerHTML = nuevoHTML;
            child.replaceWith(...span.childNodes);
          }
        } else if (child.nodeType === Node.ELEMENT_NODE && child.tagName !== 'A') {
          // Recursión en elementos que no sean <a>
          walkNodes(child);
        }
      });
    };
  
    walkNodes(doc.body);
    return doc.body.innerHTML;
  }

  let buttonBack = (userProfile.role === 'admin' && Number(localStorage.getItem("lengthSponsor")) > 1) ? [{
    title: <Link to={`${INTERNAL_LINKS.SPONSORS_DASHBOARD_LIST}`}>Back to dashboards</Link>,
    content: () => <></>,
  }] : []

  useEffect(() => {
    if(dashboards[slug]?.firstData){
      const discussionBoardNotifications = (dashboards[slug]?.firstData?.SponsorsDashboardsNotifications || []).filter(
        (sponsorsDashboardsNotification) => sponsorsDashboardsNotification.notificationType === "discussionBoard",
      );

      setHasDiscussionBoardNotification(discussionBoardNotifications.some(
        (sponsorsDashboardsNotification) => {
          return !sponsorsDashboardsNotification.readers.includes(userProfile.id)
          && sponsorsDashboardsNotification.meta.idDeliverables === null;
        },
      ))

      setHasDeliverableNotification(discussionBoardNotifications.filter(e => e.meta.idDeliverables !== null).reduce((acc, item) => {
        acc[item.meta.idDeliverables] = true;
        return acc;
      }, {}));
    }
  },[dashboards[slug]?.firstData])

  const TabData = useMemo(() => [
    {
      title: "Dashboard Members",
      content: () => !dashboards[slug]?.firstData ? (<div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',gap:'40px', height:'450px'}}>
        <Skeleton style={{width:'200px',height:'350px'}} active />
        <Skeleton style={{width:'200px',height:'350px'}} active />
        <Skeleton style={{width:'200px',height:'350px'}} active />
      </div>) : (<div className="container-content-tabs-intructors">
        {userProfile?.role === 'admin' && <div className="container-edit-icon"
          onClick={() => {
            visible.modal(true);
            visible.set({
              partnersName: dashboards[slug]?.firstData?.partnersName,
              members: dashboards[slug]?.firstData?.members,
              SponsorsDashboardsMembers: dashboards[slug]?.firstData?.SponsorsDashboardsMembers
            },'Dashboard Members')
          }}
        >
          <EditOutlined style={{color:'white',fontSize:'30px'}}/>
        </div>}
        {instructorContainer}
      </div>)
    },
    {
      title: "Onboarding",
      content: () => (
        <div className="container-content-tabs">
          {userProfile?.role === 'admin' && <div className="container-edit-icon"
            onClick={() => {
              visible.modal(true);
              visible.set({
                description: dashboards[slug]?.firstData?.description,
                checkList: dashboards[slug]?.firstData?.checkList,
                SponsorsDashboardsMembers: dashboards[slug]?.firstData?.SponsorsDashboardsMembers
              },'Onboarding')
            }}
          >
            <EditOutlined style={{color:'white',fontSize:'30px'}}/>
          </div>}
          <ScaleText
            content={<div
              className="description-camp"
              style={{ margin: "0px" }}
              dangerouslySetInnerHTML={{
                __html: reemplazarLinksPorHTML(dashboards[slug]?.firstData?.description),
              }}
            ></div>}
          />
          <h3 style={{width:'100%',textAlign:'start',paddingBottom:'20px',paddingTop:'20px'}}>Checklist ({porcent}%)</h3>
          {groupCheckbox()}
        </div>
      ),
    },
    {
      title: "Schedule",
      content: () => !dashboards[slug]?.delivers ? (<div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',gap:'40px', height:'450px'}}>
        <Skeleton style={{width:'200px',height:'350px'}} active />
        <Skeleton style={{width:'200px',height:'350px'}} active />
        <Skeleton style={{width:'200px',height:'350px'}} active />
      </div>) : (<div className="container-content-tabs">
        {userProfile?.role === 'admin' && <div className="container-edit-icon"
          onClick={() => {
            visible.modal(true);
            visible.set({
              order: dashboards[slug]?.firstData?.order,
              deliverables: dashboards[slug]?.delivers,
              SponsorsDashboardsMembers: dashboards[slug]?.firstData?.SponsorsDashboardsMembers
            },'Deliverables')
          }}
        >
          <EditOutlined style={{color:'white',fontSize:'30px'}}/>
        </div>}
        <ScaleText
          content={<Table
            style={{width:'100%'}}
            columns={dataSourceColumns}
            dataSource={orderDelivers(dashboards[slug]?.delivers)}
            rowKey="id"
          />}
        />
      </div>),
    },
    {
      title: () =>  {
        return (
        <div
          style={{
            position: "relative",
          }}
        >
          Deliverables
          {Object.keys(hasDeliverableNotification).length > 0 && (
            <span
              style={{
                position: "absolute",
                right: "-16px",
                width: "16px",
                height: "16px",
                backgroundColor: "red",
                borderRadius: "50%",
                border: "2px solid white",
              }}
            />
          )}
        </div>
      )},
      content: () => !dashboards[slug]?.delivers ? (<div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',gap:'40px', height:'450px'}}>
        <Skeleton style={{width:'200px',height:'350px'}} active />
        <Skeleton style={{width:'200px',height:'350px'}} active />
        <Skeleton style={{width:'200px',height:'350px'}} active />
      </div>) : containerDeliverables(),
    },
    // {
    //   title: "Analytics",
    //   content: () => (
    //     <div></div>
    //   ),
    // },
    {
      title: (
        <div
          style={{
            position: "relative",
          }}
        >
          Conversation Board
          {hasDiscussionBoardNotification && (
            <span
              style={{
                position: "absolute",
                right: "-16px",
                width: "16px",
                height: "16px",
                backgroundColor: "red",
                borderRadius: "50%",
                border: "2px solid white",
              }}
            />
          )}
        </div>
      ),
      content: () => 
        <FacultyCurrentDashboardItem dashboard={dashboards[slug]?.firstData} userProfile={userProfile} />
      ,
    },
    {
      title: "Additional Resources",
      content: () => (
        <div className="container-content-tabs">
          {userProfile?.role === 'admin' && <div className="container-edit-icon"
            onClick={() => {
              visible.modal(true);
              visible.set({
                aditionalResources: dashboards[slug]?.firstData?.aditionalResources,
                SponsorsDashboardsMembers: dashboards[slug]?.firstData?.SponsorsDashboardsMembers
              },'Additional Resources')
            }}
          >
            <EditOutlined style={{color:'white',fontSize:'30px'}}/>
          </div>}
          <ScaleText
            content={<div
              className="description-camp"
              style={{ margin: "0px" }}
              dangerouslySetInnerHTML={{
                __html: reemplazarLinksPorHTML(dashboards[slug]?.firstData?.aditionalResources),
              }}
            ></div>}
          />
        </div>
      ),
    },
    {
      title: "Samples and Templates",
      content: () => !dashboards[slug]?.templates ? (<div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',gap:'40px', height:'450px'}}>
        <Skeleton style={{width:'200px',height:'350px'}} active />
        <Skeleton style={{width:'200px',height:'350px'}} active />
        <Skeleton style={{width:'200px',height:'350px'}} active />
      </div>) : (
        <div className='container-list-certificates' style={{padding:'20px'}}>
          {/* {userProfile?.role === 'admin' && <div className="container-edit-icon"
            onClick={() => {
              visible.modal(true);
              visible.set({
                templates: dashboards[slug]?.templates,
                SponsorsDashboardsMembers: dashboards[slug]?.firstData?.SponsorsDashboardsMembers
              },'Samples and Templates')
            }}
          >
            <EditOutlined style={{color:'white',fontSize:'30px'}}/>
          </div>} */}
          {(dashboards[slug]?.templates || []).map(program => {
            return (<ProgramCards program={program} caseSpecial={true} />)
          })}
        </div>
      ),
    },
    ...buttonBack,
  ].filter(Boolean), [dashboards, slug, visible, porcent, hasDiscussionBoardNotification,hasDeliverableNotification,userProfile.id,,dashboards[slug]?.delivers,reduceMembers]);

  return (
    <div
      className="container-certificate-dashboard"
      style={{marginTop: "-2.5rem",paddingBottom: "15rem"}}
    >
      <div
        className="container-firstsegment-certificate"
      >
        <div className="container-left-certificate">
          <div className="certificate-dashboard-left-mobile" style={{position:'relative'}}>
            <Tabs
              activeKey={currentTab}
              tabPosition="left"
              className="certificate-program-tabs"
              onChange={(e) => {
                if((e === '2' || e === '3') && !requestState.delivers){
                  setRequestState({...requestState,delivers:1})
                }
                if(e === '4'){
                  setHasDiscussionBoardNotification(false);
                }
                if(e === '6' && !requestState.templates){
                  setRequestState({...requestState,templates:1})
                }
                setCurrentTab(e)
              }}
              destroyInactiveTabPane={true}
              items={TabData.map((item, index) => {
                return {
                  label: typeof item.title === "function" ? item.title(): item.title,
                  key: index.toString(),
                  children: item.content(),
                };
              })}
            />
          </div>
        </div>
      </div>
      <Modal
        visible={idDeliverable}
        footer={null}
        onCancel={() => setIdDeliverable(null)}
        width={1000}
        title="Chat"
      >
        <FacultyCurrentDashboardItem dashboard={dashboards[slug]?.firstData} userProfile={userProfile} deliverable={idDeliverable} />
      </Modal>
      <ModalEditInfo
        id={dashboards[slug]?.firstData?.id}
        visible={(data) => setVisible(data)}
        notifyRe={notifyRe}
        title={dashboards[slug]?.firstData?.partnersName}
        reduceMembers={reduceMembers}
        finish={(cases) => {
          if(cases === 'Dashboard Members' || cases === 'Onboarding' || cases === 'Additional Resources'){
            getSponsorsDashboardCases({id:slug, cases:'firstData', uniqueLink:slug})
          }
          if(cases === 'Deliverables'){
            getSponsorsDashboardCases({id:dashboards[slug]?.firstData?.id, cases:'delivers', uniqueLink:slug})
          }
          if(cases === 'Samples and Templates'){
            getSponsorsDashboardCases({id:dashboards[slug]?.firstData?.id, cases:'templates', uniqueLink:slug})
          }
        }}
      />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  userProfile: homeSelector(state).userProfile,
  certificateUsersInfo: courseSelector(state).certificateUsersInfo,
  ...sponsorDashboardSelector(state),
  s3Hash: envSelector(state).s3Hash,
});

const mapDispatchToProps = {
  getSponsorsDashboardCases
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardSponsors);